var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 100,
    viewBox: "0 0 99 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 100,
    fill: "#A8A8A8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AI QUIZ BOOSTER",
    clipPath: "url(#clip0_13_7334)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 8804,
    transform: "translate(-608 -5488)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 237",
    opacity: 0.3,
    d: "M-720 64.9346C-628 239.268 -394.6 561.035 -197 453.435C50 318.935 -421.5 121.935 -551 288.935C-643.804 408.612 -436 879.435 304 595.435C896 368.235 1268.33 500.768 1380.5 595.435",
    stroke: "#FFBB00",
    strokeWidth: 11
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1171274921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000014093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 34625643",
    filter: "url(#filter0_bd_13_7334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-349 -65.0652C-349 -105.934 -315.869 -139.065 -275 -139.065H979C1019.87 -139.065 1053 -105.934 1053 -65.0652V1060.93C1053 1101.8 1019.87 1134.93 979 1134.93H-275C-315.869 1134.93 -349 1101.8 -349 1060.93V-65.0652Z",
    fill: "white",
    fillOpacity: 0.05,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1171274920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 237862"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000014106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000014100"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 449",
    cx: 49.1539,
    cy: 50.0885,
    r: 49.1539,
    fill: "url(#paint0_linear_13_7334)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22 48.5304C22.1436 47.5394 22.2585 46.5484 22.4309 45.5717C23.6086 39.0942 26.754 33.7226 31.7378 29.4569C35.5439 26.1966 39.9533 24.1714 44.894 23.324C47.508 22.8788 50.1363 22.807 52.7647 23.1517C53.4972 23.2522 53.8994 23.7405 53.8132 24.3869C53.727 25.0045 53.1812 25.3779 52.4631 25.3061C43.9892 24.43 36.7935 27.087 30.9479 33.2486C27.1562 37.227 24.9874 42.0385 24.3555 47.5107C23.0628 58.7566 29.2388 69.3706 39.6373 73.823C50.122 78.3041 62.4738 75.1156 69.4541 66.139C72.384 62.3616 74.1794 58.1246 74.7108 53.3562C75.4289 46.8931 73.8634 41.0188 70.1435 35.6902C70.1004 35.6184 70.0286 35.561 69.8706 35.3743C69.8706 35.8339 69.8849 36.1642 69.8706 36.4945C69.8418 37.1265 69.411 37.543 68.8221 37.5574C68.2476 37.5574 67.7449 37.1265 67.7305 36.5233C67.7018 35.1301 67.7018 33.7226 67.7305 32.3294C67.7449 31.7405 68.1901 31.3384 68.7934 31.3384C70.1578 31.324 71.5223 31.324 72.8724 31.3384C73.533 31.3384 73.9496 31.798 73.9496 32.4156C73.9496 33.0332 73.5187 33.464 72.8436 33.4784C72.3266 33.4928 71.8239 33.4784 71.2925 33.4784C72.025 34.6274 72.7862 35.6902 73.4181 36.8105C76.2476 41.7513 77.4253 47.0654 76.9513 52.7387C75.989 64.0851 68.3481 73.5213 57.5044 76.8247C55.6803 77.3849 53.8275 77.744 51.9317 77.8876C51.7737 77.9019 51.6157 77.9594 51.4721 77.9881C50.1794 77.9881 48.8868 77.9881 47.6085 77.9881C46.9766 77.9019 46.3303 77.8301 45.6983 77.744C40.6714 77.0115 36.1472 75.0869 32.2118 71.8553C26.9551 67.5321 23.6661 62.0313 22.4452 55.3096C22.2729 54.3473 22.158 53.3706 22.0144 52.394C22 51.1013 22 49.823 22 48.5304Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M50.3514 68.8251C58.2939 68.8538 65.9061 62.5486 67.5578 53.8593C69.468 43.8916 62.7894 34.1681 52.8074 32.3728C48.2688 31.5541 44.0319 32.3872 40.0678 34.7139C39.9385 34.7857 39.8236 34.8719 39.6944 34.9293C39.1342 35.2022 38.5453 35.0442 38.2437 34.5415C37.9421 34.0245 38.0857 33.3638 38.6459 33.0478C39.6225 32.5021 40.6136 31.9276 41.6477 31.511C53.3245 26.6708 66.4806 33.3495 69.4824 45.6295C72.2687 57.019 64.8433 68.4948 53.3101 70.6348C42.1791 72.7174 31.4789 65.4355 29.3533 54.2758C28.3623 49.0909 29.3102 44.2076 32.0391 39.6834C32.4556 38.994 33.0445 38.7929 33.6046 39.1232C34.1935 39.4679 34.3084 40.0999 33.8919 40.8036C31.7949 44.2219 30.9188 47.9562 31.2491 51.9347C31.8667 59.3745 36.7213 65.5073 43.7015 67.8484C45.583 68.5091 47.522 68.7964 50.3514 68.8251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M49.5485 54.1751C46.9632 54.2038 45.1392 51.5898 46.0728 49.1482C46.202 48.8179 46.1733 48.6168 45.9148 48.3582C44.8232 47.2954 43.7604 46.2182 42.6832 45.141C42.2954 44.7532 42.1949 44.308 42.439 43.8197C42.6688 43.3457 43.0997 43.159 43.6024 43.2739C43.8609 43.3313 44.1194 43.518 44.3205 43.7048C45.369 44.7245 46.4031 45.773 47.4372 46.8214C47.6814 47.0656 47.8681 47.1518 48.2128 47.0082C49.0889 46.6347 49.9938 46.6491 50.8699 47.0082C51.2002 47.1374 51.3726 47.08 51.6024 46.8502C53.8717 44.5665 56.1553 42.2829 58.439 40.0136C58.7837 39.6689 59.1427 39.4103 59.6742 39.5827C60.3923 39.8125 60.6795 40.5881 60.263 41.22C60.1481 41.3924 59.9901 41.5504 59.8321 41.694C57.6203 43.9058 55.4085 46.132 53.1823 48.3439C52.9237 48.6024 52.8376 48.7891 52.9812 49.1626C53.9004 51.5755 52.1338 54.1464 49.5485 54.1751ZM49.5054 48.9328C48.6437 48.9328 47.9974 49.6078 47.9974 50.4695C48.0117 51.3313 48.6724 51.9776 49.5342 51.9776C50.3959 51.9633 51.0422 51.3026 51.0422 50.4265C51.0422 49.5791 50.3815 48.9328 49.5054 48.9328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M50.6101 35.8334C50.6101 36.0632 50.6245 36.293 50.6101 36.5228C50.567 37.126 50.1649 37.5281 49.6047 37.5569C49.0159 37.5712 48.5275 37.1691 48.4844 36.5802C48.4557 36.0775 48.4557 35.5748 48.4844 35.0865C48.5275 34.4833 49.0159 34.0811 49.6047 34.1098C50.1792 34.1386 50.5814 34.5407 50.6101 35.144C50.6101 35.3738 50.6101 35.6036 50.6101 35.8334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M34.9109 49.378C35.1407 49.378 35.3705 49.3636 35.6003 49.378C36.2035 49.4067 36.6056 49.8232 36.62 50.3977C36.6344 50.9722 36.2609 51.4605 35.6864 51.5036C35.155 51.5467 34.6092 51.5467 34.0778 51.5036C33.5033 51.4462 33.1443 50.9579 33.1586 50.369C33.1873 49.8088 33.5751 49.4067 34.1496 49.378C34.4082 49.3636 34.6523 49.378 34.9109 49.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M64.1539 49.3921C64.3837 49.3921 64.6135 49.3778 64.8433 49.3921C65.4609 49.4352 65.8774 49.8805 65.8774 50.4693C65.8774 51.0725 65.4609 51.5034 64.8433 51.5322C64.3837 51.5465 63.9097 51.5465 63.4501 51.5322C62.8325 51.5034 62.416 51.0725 62.416 50.4693C62.416 49.8805 62.8325 49.4352 63.4501 49.3921C63.6943 49.3778 63.9241 49.3921 64.1539 49.3921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M50.5824 65.0903C50.5824 65.3201 50.5968 65.5499 50.5824 65.7797C50.5394 66.3973 50.0941 66.8138 49.5052 66.8138C48.902 66.8138 48.4711 66.4117 48.4424 65.7797C48.428 65.3201 48.428 64.8461 48.4424 64.3865C48.4711 63.7833 48.8877 63.3811 49.4478 63.3524C50.051 63.3381 50.5106 63.7402 50.5681 64.3291C50.6112 64.5876 50.5824 64.8461 50.5824 65.0903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M56.9868 24.013C57.6044 24.0274 58.0496 24.487 58.0353 25.1046C58.0209 25.6934 57.5613 26.153 56.9724 26.153C56.3836 26.153 55.8809 25.6504 55.8809 25.0615C55.8809 24.4726 56.3692 23.9987 56.9868 24.013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M36.836 36.6955C36.8504 37.3131 36.3908 37.7727 35.7732 37.787C35.1556 37.787 34.6816 37.3274 34.6816 36.7098C34.6816 36.1353 35.1556 35.6614 35.7301 35.6327C36.3477 35.6183 36.8217 36.0779 36.836 36.6955Z",
    fill: "white"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_13_7334",
    x: -466,
    y: -252.065,
    width: 1636,
    height: 1508,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_13_7334"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 58.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.298039 0 0 0 0 0.341176 0 0 0 0 0.729412 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_13_7334",
    result: "effect2_dropShadow_13_7334"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_13_7334",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_7334",
    x1: 0.152344,
    y1: 28.9346,
    x2: 87.6523,
    y2: 82.9346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8542F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A896F4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_7334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 8804,
    fill: "white",
    transform: "translate(-608 -5488)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeCard);
export default __webpack_public_path__ + "static/media/timeCard.9347d159845a192790e795f48d2fde4a.svg";
export { ForwardRef as ReactComponent };